// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.azJ3eSddhXAh4Z2iQJog{flex-direction:column;gap:15px;display:flex}.o8pCJr67YjA3t4w6p9Lo{gap:4px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `azJ3eSddhXAh4Z2iQJog`,
	"section": `o8pCJr67YjA3t4w6p9Lo`
};
export default ___CSS_LOADER_EXPORT___;
